export default __webpack_public_path__ + "static/media/recurrence.46e307e3.svg";